module.exports = __webpack_public_path__ + "static/media/10-login.008967d9.png";